













import { RelatedTag } from '@empathy/search-types';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class Tag extends Vue {
  @Prop()
  tag: RelatedTag;

  @Prop()
  clickedEvent: string;

  emitEvent() {
    this.$x.emit(this.clickedEvent, this.tag);
  }
}
